<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="back">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-grid>
        <ion-row class="row-boxed mt-20 text-left">
          <ion-col class="text-left" size="12" size-md="4">
            <ion-button @click="openFilter" expand="block" color="secondary"><span class="btn-left text-lower">Filters</span></ion-button>
          </ion-col>
          <ion-col class="text-left" size="12" size-md="4">
            <ion-button @click="openOrder" expand="block" color="secondary"><span class="btn-left text-lower">Order</span></ion-button>
          </ion-col>
          <ion-col class="text-left" size="12" size-md="4">
            <ion-button @click="preExportPdf" expand="block" color="secondary"><span class="btn-left text-lower">Export PDF</span></ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="row-boxed mt-20">
          <ion-col size="12">
            <div class="title text-left block mb-10">{{ report.name }}</div>
            <div class="fix-pl-50">
              <report-index :allowedColors="allowedColors" :allowedIndices="allowedIndices" @indexDetails="(idx) => indexDetails(idx)" :indices="indices"></report-index>
            </div>
          </ion-col>
        </ion-row>

      </ion-grid>

      <modal-export
        v-if="modalExport"
        @close="modalExport = 0"
        @submit="exportPdf"
        :report="report"
      ></modal-export>

      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
import PopoverFilters from "./partials/PopoverFilters"
import PopoverOrders from "./partials/PopoverOrders"
import ReportIndex from "./partials/ReportIndex"
import ModalExport from "./partials/ModalExport";
export default {
  name: "YachtReport",
  components: {
    ModalExport,
    ReportIndex
  },
  computed: {
    allowedColors: function() {
      let allowed = []
      for (const k in this.filtersColor) {
        if (Object.hasOwnProperty.call(this.filtersColor, k)) {
          const value = this.filtersColor[k];
          if(value) {
            allowed.push(k)
          }
        }
      }
      return allowed
    },
    allowedIndices: function() {
      let allowed = []
      for (const k in this.filtersIndex) {
        if (Object.hasOwnProperty.call(this.filtersIndex, k)) {
          const value = this.filtersIndex[k];
          if(value) {
            allowed.push(k)
          }
        }
      }
      return allowed
    },
  },
  data: function() {
    return {
      indices: [],
      indices_orig: [],
      report: {},
      loader: true,
      filtersColor: {
        red: true,
        green: true,
        yellow: true,
        nocolor: true,
      },
      filtersIndex: {},
      order: 'ref',
      orderType: 'asc',
      divHeight: 0,
      pdf: '',
      modalExport: false
    }
  },
  methods: {
    preExportPdf: function() {
      this.modalExport = true
    },
    exportPdf: function(data) {
      window.open(this.apiUrl + '/pdf?id=' + this.$route.params.id + '&data=' + data, '_blank')
    },
    back: function() {
      this.$router.push('/report/'+this.report.yacht_id)
    },
    indexDetails: async function(idx) {
      if(idx.type) {
        this.$router.push({name: 'compile-' + (idx.type == 'tt' ? 'text' : 'index'), params: { id: idx.id } });
      } else {
        const toast = await this.$ionic.toastController.create({
          message: 'Index type is not set properly. Contact the administrator.',
          color: 'danger',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      }
    },
    openFilter: async function(ev){
      const popover = await this.$ionic.popoverController.create({
        component: PopoverFilters,
        event: ev,
        translucent: true,
        componentProps: {
          propsData: {
            filtersIndex: this.filtersIndex,
            filtersColor: this.filtersColor,
            filterCod: this.filterCod,
            filterRef: this.filterRef,
          },
        },
      });
      
      await popover.present();
      let res = await popover.onDidDismiss();
      if(res && res.data) {
        this.filtersColor = res.data.filtersColor
        this.filtersIndex = res.data.filtersIndex
        this.filterCod = res.data.filterCod
        this.filterRef = res.data.filterRef
      }
    },
    orderIndices: function() {
      this.loader = true
      Vue.set(this, 'indices', []);
      this.getIndices()
      this.loader = false
    },
    openOrder: async function(ev){
      const popover = await this.$ionic.popoverController.create({
        component: PopoverOrders,
        event: ev,
        translucent: true,
        componentProps: {
          propsData: {
            order: this.order,
            orderType: this.orderType,
          },
        },
      });
      
      await popover.present();
      let res = await popover.onDidDismiss();
      if(res && res.data) {
        let change = false
        if(this.order != res.data.order) {
          this.order = res.data.order
          change = true
        }
        if(this.orderType != res.data.orderType) {
          this.orderType = res.data.orderType
          change = true
        }
        if(change) {
          this.orderIndices()
        }
      }
    },
    getIndices: async function() {
      await axios.post(this.apiUrl + '/api/v1/get-indices', { api_token: this.$store.state.api_token, id: this.$route.params.id, order: { type: this.orderType, val: this.order } })
      .then((response) => {
        let res = response.data
        if(res.data.length) {
          let i = 0
          while (i < res.data.length) {
            Vue.set(this.indices, this.indices.length, res.data[i]);
            Vue.set(this.indices_orig, this.indices_orig.length, res.data[i]);
            if (res.data[i].parent == 0) {
              Vue.set(this.filtersIndex, res.data[i].cod, true);
            }
            i++
          }
        }
      })
    }
  },
  mounted: async function() {
    this.getIndices()

    await axios.post(this.apiUrl + '/api/v1/get-report', { api_token: this.$store.state.api_token, id: this.$route.params.id })
    .then((response) => {
      let res = response.data
      if(res.data) {
        this.report = res.data
      }
    })
    this.loader = false;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
